import React, { useState, useEffect, useRef } from "react";
import "./Internationalrelation.css";
import { SLIDER_AUTOPLAY_DELAY_MS } from "../constants/sliderTiming";
import useScrollAnimation from "../constants/useScrollAnimation";

const images = [
  "/images/international/pic_1.jpg",
  "/images/international/pic_2.jpg",
  "/images/international/pic_3.jpg",
  "/images/international/pic_4.jpg",
  "/images/international/pic_5.jpg",

];

const Internationalrelation = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [transitioning, setTransitioning] = useState(false);
  const activeIndexRef = useRef(0);
  const [contentRef, isContentVisible] = useScrollAnimation(0.2);

  useEffect(() => {
    activeIndexRef.current = activeIndex;
  }, [activeIndex]);

  useEffect(() => {
    const interval = window.setInterval(() => {
      goToSlide((activeIndexRef.current + 1) % images.length);
    }, SLIDER_AUTOPLAY_DELAY_MS);

    return () => window.clearInterval(interval);
  }, []);

  const goToSlide = (targetIndex) => {
    if (targetIndex === activeIndexRef.current) return;

    setTransitioning(true);

    window.setTimeout(() => {
      setActiveIndex(targetIndex);
      setTransitioning(false);
    }, 180);
  };

  const getThumbnails = () => {
    return [
      images[(activeIndex + 1) % images.length],
      images[(activeIndex + 2) % images.length],
      images[(activeIndex + 3) % images.length],
      images[(activeIndex + 4) % images.length],
      images[activeIndex],
    ];
  };

  const thumbnails = getThumbnails();

  const handleThumbClick = (index) => {
    goToSlide(index);
  };

  return (
    <section className="ir-section">
      <div ref={contentRef} className="ir-wrapper">

        <div className={`ir-left schools-left ${isContentVisible ? "animate-in" : ""}`}>

          <div className="ir-main">
            <img
              src={images[activeIndex]}
              className={`ir-main-image ${transitioning ? "is-transitioning" : ""}`}
              alt=""
            />
          </div>

          <div className="ir-thumbs">
            {thumbnails.map((img, pos) => {
              const actualIndex =
                pos === 4
                  ? activeIndex
                  : (activeIndex + pos + 1) % images.length;

              return (
                <img
                  key={pos}
                  src={img}
                  className={`thumb ${pos === 4 ? "active" : ""}`}
                  onClick={() => handleThumbClick(actualIndex)}
                  alt=""
                />
              );
            })}
          </div>
        </div>

        <div className={`ir-right schools-right ${isContentVisible ? "animate-in" : ""}`}>

          <div className="ir-progressbar">
            {images.map((_, i) => (
              <div key={i} className={i === activeIndex ? "bar active" : "bar"}></div>
            ))}

            <span className="count">
              <span className="active-count">{activeIndex + 1}</span>
              <span className="total">/{images.length}</span>
            </span>
          </div>
          <div className="section-title-body">
            <div>
              <h3 className="section-title-hm">International Relation</h3>
            </div>

          </div>



          <p className="ir-text">
            At Techno India Group Public School (TIGPS), we believe in nurturing global citizens who are not only academically strong but also possess a deep understanding of different cultures and perspectives. Our vibrant International Relations program fosters a spirit of collaboration and exchange.  We are thrilled to announce that a student from TIGPS Bolpur has been selected to participate in the prestigious Salam International Youth Film Festival in Azerbaijan!  TIGPS made us proud by securing a top position at the National.
          </p>

          <a href="#" class="btn-com school-view mt-5">Read more</a>
        </div>

      </div>
    </section>
  );
};

export default Internationalrelation;
